import React from 'react';
import PropTypes from 'prop-types';
import { getExtraField } from 'gatsby-core-theme/src/helpers/getters';
import LinkList from 'gatsby-core-theme/src/components/molecules/link-list';
import { copyrightText } from 'gatsby-core-theme//src/helpers/getters.mjs';
import useTranslate from '~hooks/useTranslate/useTranslate';
import LazyImage from '~hooks/lazy-image';
import styles from './footer.module.scss';

const Footer = ({
  section,
  logo = '../../../../../images/logo.svg',
  imgWidth,
  imgHeight,
  customBGColor,
}) => {
  const footerLinks = getExtraField(section?.extra_fields, 'footer_links');
  const footerLogos = getExtraField(section?.extra_fields, 'footer_logos');
  const gamblingText = getExtraField(section?.extra_fields, 'gambling_text');
  const copyrightCustomText =
    getExtraField(section?.extra_fields, 'copyright_text') || copyrightText();

  return (
    <footer
      className={styles.footer}
      style={{
        '--footer-bg': customBGColor,
      }}
    >
      <div className={styles.footerContainer}>
        <div className={styles.footerTop}>
          <LazyImage
            alt="Site footer logo"
            width={imgWidth || 182}
            height={imgHeight || 48}
            src={logo}
            className={styles?.logo || ''}
          />
          <span>{copyrightCustomText}</span>
          {footerLinks && (
            <div className={styles?.footerLinks || ''}>
              <LinkList lists={footerLinks} gtmClass="mobile-menu-gtm logo-cta" />
            </div>
          )}
        </div>
        <div className={styles.footerBottom}>
          <span>{useTranslate('in_compliance', 'In compliance with:')}</span>

          <div className={styles?.logos || ''}>
            {footerLogos && (
              <LinkList
                showListTitle={false}
                imageOnly
                singleList
                lists={footerLogos}
                gtmClass="mobile-menu-gtm logo-cta"
                width={130}
                height={140}
              />
            )}
          </div>

          <p>{gamblingText}</p>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  section: PropTypes.shape({
    extra_fields: PropTypes.shape({}),
  }),
  logo: PropTypes.string,
  imgWidth: PropTypes.number,
  imgHeight: PropTypes.number,
  customBGColor: PropTypes.string,
};

export default Footer;
